// The members' list: its order and its search (A5; D25).
import type { AdminMember } from '@grc/shared';
import { LOCALE } from '../../i18n';

const collator = new Intl.Collator(LOCALE, { sensitivity: 'base' });

/** The list's order: by the name the members see, then by username. */
export function byName(a: AdminMember, b: AdminMember): number {
  return collator.compare(a.displayName, b.displayName) || collator.compare(a.username, b.username);
}

/**
 * What the search compares: no case and no accents, and the dotless ı as i, so "ozge" finds Özge
 * and "isik" finds Işık, typed on any keyboard.
 */
export function folded(text: string): string {
  return text.normalize('NFD').replace(/\p{M}/gu, '').replace(/ı/g, 'i').toLowerCase();
}

/** Whether the member's display name or username has what was typed in it. */
export function matches(member: AdminMember, query: string): boolean {
  const wanted = folded(query.trim());
  return (
    wanted === '' ||
    folded(member.displayName).includes(wanted) ||
    folded(member.username).includes(wanted)
  );
}
